/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */

import { useAuth0 } from "@auth0/auth0-react";
import Pagination from "@material-ui/lab/Pagination";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import { TableContainer } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ExportSvgComponent from "@mui/icons-material/FileDownload";
import PrintSvgComponent from "@mui/icons-material/LocalPrintshop";
import Paper from "@mui/material/Paper";
import { pdf } from "@react-pdf/renderer";
import AuthService from "Lib/API/Auth";
import InfoTooltip from "components/InfoTooltip";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import Button from "components/button/Button.jsx";
import Loader from "components/loader/Loader";
import { saveAs } from "file-saver";
import { formatDate } from "helper/dateFormat.js";
import { numberFormat } from "helper/numberFormat";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import * as _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import CsvDownloader from "react-csv-downloader";
import { sanitizeRows } from "utils/exportSanitize";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { formatPhoneNumber } from "react-phone-number-input";
import { DateFormetContext } from "../../../app/App.js";
import "../../Members/MemberTables/memberTablse.scss";
import Filter from "../filter";
import MailingLabelsDocument from "./MailingLabelsDocument.jsx";
import { fetchProducts, filterOrder, filterOrderFieldType, getFilterData } from "./filterSlice";
import { resolveFieldValue } from "./resolveFieldValue";
import SaveFilter from "./saveFilter";


const SearchResult = ({ goToOrder, id }) => {
  const dispatch = useDispatch();
  const { push } = useHistory();
  const { getAccessTokenSilently } = useAuth0();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const [columnsDownload, setColumnsDownload] = React.useState([]);
  const [datasDownload, setDatasDownload] = React.useState([]);
  const state = useSelector((state) => state.filterParams.filterTable);
  const totalCount = useSelector((state) => state.filterParams.filterTotalCount);
  const { fieldsOrder, orderFieldType, selectedAddress, fieldsGroup, filterLoading } = useSelector((state) => state.filterParams)
  const [currentPage, setCurrentPage] = React.useState(1);
  const ITEMS_PER_PAGE = 25;
  const isFetchingRef = React.useRef(false);
  const hasFetchedRef = React.useRef(false);
  const [sortField, setSortField] = React.useState(null);
  const [sortDir, setSortDir] = React.useState(1); // 1 = asc, -1 = desc
  const queryParams = new URLSearchParams(window.location.search);
  const filterId = queryParams.get("id");
  const [filterDisplay, setFilterDisplay] = React.useState([]);
  const [filters, setFilters] = React.useState([]);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [exportDatas, setExportDatas] = React.useState(null);
  const [exportLoading, setExportLoading] = React.useState(false);
  const exportCsvRef = React.useRef(null);
  const [printList, setPrintList] = React.useState(null);
  const [printLoading, setPrintLoading] = React.useState(false);
  const [list, setList] = React.useState([]);
  const [getDataByIdLoading, setGetDataByIdLoading] = useState(false)
  const [sortableLookup, setSortableLookup] = React.useState({})

  React.useEffect(() => {
    const loadSortable = async () => {
      try {
        const token = await getAccessTokenSilently();
        const res = await AuthService.getFilterParams(token, true);
        const lookup = {};
        if (Array.isArray(res)) {
          res.forEach((collection) => {
            collection.fieldsGroup?.forEach((field) => {
              lookup[field.fieldName] = field.sortable ?? false;
            });
          });
        }
        setSortableLookup(lookup);
      } catch (_) {}
    };
    loadSortable();
  }, []);

  let orgData = JSON.parse(
    localStorage.getItem("organization") !== "undefined"
      ? localStorage.getItem("organization")
      : "{}"
  );


  const selectedFieldorders = fieldsOrder
  useEffect(() => {
    if (filterDisplay?.length > 0 && !fieldsOrder) {
      dispatch(filterOrder(filterDisplay));
    }
  }, [filterDisplay]);

  const getOrderKeys = selectedFieldorders?.map((order) => {
    let key;
    Object.keys(
      typeof datasDownload[0] === "object" && datasDownload[0]
    )?.forEach((keyy) => {
      if (keyy === order?.fieldName) {
        key = keyy;
      }
      if (order?.displayName === "Active Address") {
        key = "account.addresses.active_address";
      }
      if (order?.displayName === "Active City") {
        key = "account.addresses.active_city";
      }
      if (order?.displayName === "Active Address Line 2") {
        key = "account.addresses.active_addressLine2";
      }

      if (order?.displayName === "Active State") {
        key = "account.addresses.active_state";
      }
      if (order?.displayName === "Active Zip code") {
        key = "account.addresses.active_zip_code";
      }
      if (order?.displayName === "Active Neighborhood") {
        key = "account.addresses.active_neighborhood";
      }
      if (order?.displayName === "Active Country") {
        key = "account.addresses.active_country";
      }
      if (order?.displayName === "Billing Address") {
        key = "account.addresses.billing_address";
      }
      if (order?.displayName === "Billing Address Line 2") {
        key = "account.addresses.billing_addressLine2";
      }
      if (order?.displayName === "Billing City") {
        key = "account.addresses.billing_city";
      }
      if (order?.displayName === "Billing State") {
        key = "account.addresses.billing_state";
      }
      if (order?.displayName === "Billing Zip code") {
        key = "account.addresses.billing_zip_code";
      }
      if (order?.displayName === "Billing Neighborhood") {
        key = "account.addresses.billing_neighborhood";
      }
      if (order?.displayName === "Billing Country") {
        key = "account.addresses.billing_country";
      }
      if (order?.displayName === "Address") {
        key = "location.formattedAddress";
      }
      if (order?.displayName?.includes("Adult")) {
        key = `account[${order?.fieldName}]`
      }
      if (order?.displayName === "Adult 1 First Name") {
        key = "account.adult1FirstName";
      }
      if (order?.displayName === "Adult 1 Last Name") {
        key = "account.adult1LastName";
      }
      if (order?.displayName === "Adult 2 First Name") {
        key = "account.adult2FirstName";
      }
      if (order?.displayName === "Adult 2 Last Name") {
        key = "account.adult2LastName";
      }
      if (order?.displayName === "Adult 1 Mobile") {
        key = "account.adult1Mobile";
      }
      if (order?.displayName === "Adult 2 Mobile") {
        key = "account.adult2Mobile";
      }
      if (order?.displayName === "Adult 1 Email") {
        key = "account.adult1Email";
      }
      if (order?.displayName === "Adult 2 Email") {
        key = "account.adult2Email";
      }
      if (order?.displayName === "Adult 1 Birth date") {
        key = "account.adult1BirthDate";
      }
      if (order?.displayName === "Adult 2 Birth date") {
        key = "account.adult2BirthDate";
      }
      if (order?.displayName === "Adult 1 Sex") {
        key = "account.adult1Sex";
      }
      if (order?.displayName === "Adult 2 Sex") {
        key = "account.adult2Sex";
      }
      if (order?.displayName === "Adult 1 Title") {
        key = "account.adult1Title";
      }
      if (order?.displayName === "Adult 2 Title") {
        key = "account.adult2Title";
      }
      if (order?.displayName === "Hide on member directory") {
        key = "account.hideDirectory";
      }
      if (order?.displayName === "Hide email address on member directory") {
        key = "account.hideEmail";
      }
      if (order?.displayName === "Hide mobile number on member directory") {
        key = "account.hideMobile";
      }
      if (order?.displayName === "Hide home number on member directory") {
        key = "account.hideHomeNumber";
      }
      if (order?.displayName === "Hide address on member directory") {
        key = "account.hideAddress";
      }

    });
    return key;
  });
  const orderDatasDownload = datasDownload.map((item) => {
    let obj = {};
    getOrderKeys.forEach((ele) => {
      if (ele in item) {
        obj[ele] = item[ele];
      }
    });
    return obj;
  });

  const displayNameToExportId = {
    "Adult 1 First Name": "account.adult1FirstName",
    "Adult 1 Last Name": "account.adult1LastName",
    "Adult 2 First Name": "account.adult2FirstName",
    "Adult 2 Last Name": "account.adult2LastName",
    "Adult 1 Mobile": "account.adult1Mobile",
    "Adult 2 Mobile": "account.adult2Mobile",
    "Adult 1 Email": "account.adult1Email",
    "Adult 2 Email": "account.adult2Email",
    "Adult 1 Birth date": "account.adult1BirthDate",
    "Adult 2 Birth date": "account.adult2BirthDate",
    "Adult 1 Sex": "account.adult1Sex",
    "Adult 2 Sex": "account.adult2Sex",
    "Adult 1 Title": "account.adult1Title",
    "Adult 2 Title": "account.adult2Title",
    "Home 1": "account.home1",
    "Home 2": "account.home2",
    "Category": "account.category",
    "Active Address": "account.addresses.active_address",
    "Active City": "account.addresses.active_city",
    "Active State": "account.addresses.active_state",
    "Active Zip code": "account.addresses.active_zip_code",
    "Active Neighborhood": "account.addresses.active_neighborhood",
    "Active Country": "account.addresses.active_country",
    "Active Address Line 2": "account.addresses.active_addressLine2",
    "Billing Address": "account.addresses.billing_address",
    "Billing City": "account.addresses.billing_city",
    "Billing State": "account.addresses.billing_state",
    "Billing Zip code": "account.addresses.billing_zip_code",
    "Billing Neighborhood": "account.addresses.billing_neighborhood",
    "Billing Country": "account.addresses.billing_country",
    "Billing Address Line 2": "account.addresses.billing_addressLine2",
    "Archived account": "account.archived",
    "Archived contact": "archived",
    "Contact id": "_id",
  };

  const orderColumnsDownload = selectedFieldorders?.map((order) => {
    let column;
    if (displayNameToExportId[order?.displayName]) {
      column = {
        id: displayNameToExportId[order?.displayName],
        displayName: order?.displayName,
        dataForColumn: [undefined],
      };
    } else if (
      columnsDownload?.find(
        (col) =>
          order?.displayName?.toLowerCase() === col?.displayName?.toLowerCase()
      )
    ) {
      column = columnsDownload?.find(
        (col) =>
          order?.displayName?.toLowerCase() === col?.displayName?.toLowerCase()
      );
    } else {
      column = {
        id: order?.fieldName,
        displayName: order?.displayName,
        dataForColumn: [undefined],
      };
    }

    return column;
  });

  let newFieldsOrderObjects =
    fieldsOrder?.filter((el) => typeof el === "object" && el !== null) || [];
  let newFieldsOrder =
    newFieldsOrderObjects?.length !== 0
      ? [
        ...newFieldsOrderObjects,
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing Zip code") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing Zip Code",
          fieldName: "account.addresses.billing_zip_code",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active Zip code") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active Zip code",
          fieldName: "account.addresses.active_zip_code",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active City") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active City",
          fieldName: "account.addresses.active_city",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active City") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active City",
          fieldName: "account.addresses.active_city",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active Address Line 2") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active Address Line 2",
          fieldName: "account.addresses.active_addressLine2",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing Address Line 2") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing Address Line 2",
          fieldName: "account.addresses.billing_addressLine2",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing City") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing City",
          fieldName: "account.addresses.billing_city",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing State") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing State",
          fieldName: "account.addresses.billing_state",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active State") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active State",
          fieldName: "account.addresses.active_state",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing Address") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing Address",
          fieldName: "account.addresses.billing_address",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active Address") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Acvive Address",
          fieldName: "account.addresses.active_address",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Active Neighborhood") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active Neighborhood",
          fieldName: "account.addresses.active_neighborhood",
        },
        newFieldsOrderObjects?.find((item) => {
          if (item?.displayName == "Billing Neighborhood") {
            return true;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing Neighborhood",
          fieldName: "account.addresses.billing_neighborhood",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Billing Country") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Billing Country",
          fieldName: "account.addresses.billing_country",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Active Country") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Active Country",
          fieldName: "account.addresses.active_country",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 First Name") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 First Name",
          fieldName: "account.adult1FirstName",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Title") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Title",
          fieldName: "account.adult1Title",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Title") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Title",
          fieldName: "account.adult2Title",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Last Name") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Last Name",
          fieldName: "account.adult1LastName",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 First Name") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 First Name",
          fieldName: "account.adult2FirstName",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Last Name") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Last Name",
          fieldName: "account.adult2LastName",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Mobile") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Mobile",
          fieldName: "account.adult1Mobile",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Mobile") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Mobile",
          fieldName: "account.adult2Mobile",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Email") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Email",
          fieldName: "account.adult1Email",
        },

        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Email") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Email",
          fieldName: "account.adult2Email",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Birth date") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Birth date",
          fieldName: "account.adult1BirthDate",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Birth date") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Birth date",
          fieldName: "account.adult2BirthDate",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 1 Sex") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 1 Sex",
          fieldName: "account.adult1Sex",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Adult 2 Sex") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Adult 2 Sex",
          fieldName: "account.adult2Sex",
        },

        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Hide on member directory") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Hide on member directory",
          fieldName: "account.hideDirectory",
        },

        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Hide email address on member directory") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Hide email address on member directory",
          fieldName: "account.hideEmail",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Hide mobile number on member directory") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Hide mobile number on member directory",
          fieldName: "account.hideMobile",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Hide home number on member directory") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Hide home number on member directory",
          fieldName: "account.hideHomeNumber",
        },
        newFieldsOrderObjects?.find((o, i) => {
          if (o?.displayName == "Hide address on member directory") {
            return o;
          }
        }) && {
          collectionName: "Account",
          displayName: "Hide address on member directory",
          fieldName: "account.hideAddress",
        },
      ]
      : [];

  const columns = [
    {
      field: "profile_img",
      headerName: "Profile Picture",
      width: 220,
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col">
            <div className="user-icon d-flex flex-row">
              <img
                src={
                  data?.row?.profile_img || "https://via.placeholder.com/150"
                }
                style={{ height: "50px", borderRadius: "3px", width: "50px" }}
              />
            </div>
          </div>
        );
      },
    },
    {
      field: "first_name",
      headerName: "First Name",
      width: 220,
      headerClassName: "report-table-name-cell",
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col h-100">
            <div className="name-container d-flex align-items-center flex-column">
              {data?.row?.first_name && (
                <>
                  <p
                    className="id-container m-0 p-0"
                    style={{
                      width: "200px",
                      color: "grey",
                      fontWeight: "100",
                      fontSize: "13px",
                    }}
                  >
                    {data?.row?.first_name}
                  </p>
                </>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "hebrew_name",
      headerName: "Hebrew Name",
      width: 220,
      headerClassName: "report-table-name-cell",
      renderCell: (data) => {
        return (
          <div className="user-cotainer-home col h-100">
            <div className="name-container d-flex align-items-center flex-column">
              {data?.row?.hebrew_name && (
                <>
                  <p
                    className="id-container m-0 p-0"
                    style={{
                      width: "200px",
                      color: "grey",
                      fontWeight: "100",
                      fontSize: "13px",
                    }}
                  >
                    {data?.row?.hebrew_name}
                  </p>
                </>
              )}
            </div>
          </div>
        );
      },
    },
    {
      field: "middle_name",
      headerName: "Middle Name",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.middle_name ? data?.row?.middle_name : "-"}
          </div>
        );
      },
    },
    {
      field: "last_name",
      headerName: "Last Name",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.last_name ? data?.row?.last_name : "-"}
          </div>
        );
      },
    },
    {
      field: "date_of_birth",
      headerName: "DOB",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.date_of_birth
              ? formatDate({ date: data?.row?.date_of_birth, formatType: "defaultWithUTC" })
              : "-"}
          </div>
        );
      },
    },
    {
      field: "age",
      headerName: "age",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.age}</div>;
      },
    },
    {
      field: "ageYear",
      headerName: "ageYear",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageYear}</div>;
      },
    },
    {
      field: "ageDay",
      headerName: "ageDay",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageDay}</div>;
      },
    },
    {
      field: "ageMonth",
      headerName: "ageMonth",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.ageMonth}</div>;
      },
    },
    {
      field: "nickname",
      headerName: "nickname",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.nickname}</div>;
      },
    },
    {
      field: "addressLine2",
      headerName: "addressLine2",
      width: 270,
      renderCell: (data) => {
        return <div style={{ color: "grey" }}>{data?.row?.addressLine2}</div>;
      },
    },
    {
      field: "next_birthday",
      headerName: "Next Birthday",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.next_birthday
              ? formatDate({ date: data?.row?.next_birthday, formatType: "defaultWithUTC" })
              : "-"}
          </div>
        );
      },
    },
    {
      field: "next_anniversary",
      headerName: "Next Anniversary",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.next_anniversary
              ? formatDate({ date: data?.row?.next_anniversary, formatType: "defaultWithUTC" })
              : "-"}
          </div>
        );
      },
    },
    {
      field: "account.join_date",
      headerName: "JOIN NAME",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.join_date
            ? formatDate({ date: data?.row?.account?.join_date, formatType: "defaultWithUTC" })
            : "-"}
        </div>
      ),
    },
    {
      field: "account.numberOfFamilyMembers",
      headerName: "NUMBER OF FAMILY MEMBER",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.account?.numberOfFamilyMembers}
          </div>
        );
      },
    },
    {
      field: "relationship",
      headerName: "Relationship",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.relationship || "-"}</div>
      ),
    },
    {
      field: "zip_code",
      headerName: "Zip Code",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.zip_code || "-"}</div>
      ),
    },
    {
      field: "city",
      headerName: "City",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.city || "-"}</div>
      ),
    },
    {
      field: "state",
      headerName: "State",
      width: 220,
      headerClassName: "report-table-name-cell",
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.state || "-"}</div>
      ),
    },
    {
      field: "religion",
      headerName: "Religion",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.religion || "-"}</div>
      ),
    },
    {
      field: "title",
      headerName: "Title",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.title || "-"}</div>
      ),
    },
    {
      field: "gender",
      headerName: "Sex",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.gender || "-"}</div>
      ),
    },
    {
      field: "email_address",
      headerName: "EMAIL",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.email_address || "-"}</div>
      ),
    },
    {
      field: "mobile_number",
      headerName: "Mobile Number",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.mobile_number ? formatPhoneNumber(data?.row?.mobile_number) : "-"}</div>
      ),
    },
    {
      field: "home_phone",
      headerName: "HOME PHONE",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.home_phone || "-"}</div>
      ),
    },
    {
      field: "pronounce",
      headerName: "Pronounce",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.pronounce || "-"}</div>
      ),
    },
    {
      field: "social_status",
      headerName: "Status",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.social_status || "-"}</div>
      ),
    },
    {
      field: "emergency_contact_number",
      headerName: "Emergency Contact Number",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.emergency_contact_number || "-"}
        </div>
      ),
    },
    {
      field: "occupation",
      headerName: "OCCUPATION",
      description: "This column has a value getter and is not sortable.",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.occupation || "-"}</div>
      ),
    },
    {
      field: "anniversary_date",
      headerName: "Anniversary",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.anniversary_date
            ? formatDate({ date: data?.row?.anniversary_date, formatType: "defaultWithUTC" })
            : "-"}
        </div>
      ),
    },
    {
      field: "metva_date",
      headerName: "Bar/Bat Mitzvah",
      sortable: false,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.metva_date
            ? formatDate({ date: data?.row?.metva_date, formatType: "defaultWithUTC" })
            : "-"}
        </div>
      ),
    },
    {
      field: "address",
      headerName: "ADDRESS",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.address || "-"}</div>
      ),
    },
    {
      field: "account.family_name",
      headerName: "FAMILY NAME",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.family_name || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.billing_type.title",
      headerName: "BILLING TYPE",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.payment?.billing_type?.title || "-"}
        </div>
      ),
    },
    {
      field: "account.admin_contact",
      headerName: "ADMIN CONTACT",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.admin_contact || "-"}
        </div>
      ),
    },
    {
      field: "account.admin_name",
      headerName: "ADMIN NAME",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.family_name || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.account_type",
      headerName: "ACCOUNT TYPE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.payment?.account_type || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_zip_code",
      headerName: "BILLING ZIP CODE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.zip_code;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_zip_code",
      headerName: "ACTIVE ZIP CODE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.zip_code;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_city",
      headerName: "BILLING CITY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_city",
      headerName: "ACTIVE CITY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_addressLine2",
      headerName: "ACTIVE ADDRESS LINE 2",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.addressLine2;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_addressLine2",
      headerName: "BILLING ADDRESS LINE 2",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.addressLine2;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "location.formattedAddress",
      headerName: "LOCATION ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.location.formattedAddress ?? "-"}
        </div>
      ),
    },

    {
      field: "account.addresses.active_neighborhood",
      headerName: "ACTIVE NEIGHBORHOOD",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.neighborhood;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_neighborhood",
      headerName: "BILLING NEIGHBORHOOD",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.neighborhood;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_country",
      headerName: "ACTIVE COUNTRY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.country;
            }
          }) || "-"}
        </div>
      ),
    },

    {
      field: "account.addresses.billing_country",
      headerName: "BILLING COUNTRY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.country;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_address",
      headerName: "ACTIVE ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.location?.formattedAddress?.split(",")[0];
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_address",
      headerName: "BILLING ADDRESS",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.location?.formattedAddress?.split(",")[0];
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.billing_state",
      headerName: "BILLING STATE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.addresses.active_state",
      headerName: "ACTIVE STATE",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.city;
            }
          }) || "-"}
        </div>
      ),
    },
    {
      field: "account.account_id",
      headerName: "ACCOUNT ID",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.account_id || "-"}
        </div>
      ),
    },
    {
      field: "account.old_account_id",
      headerName: "OLD ACCOUNT ID",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.old_account_id || "-"}
        </div>
      ),
    },
    {
      field: "account.payment.account_sub_type.title",
      headerName: "CATEGORY",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.account_sub_type?.title || "-"}
        </div>
      ),
    },
    {
      field: "tags",
      headerName: "CONTACT TAGS",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.tags || "-"}</div>
      ),
    },
    {
      field: "account.tags",
      headerName: "ACCOUNT TAGS",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>{data?.row?.tags || "-"}</div>
      ),
    },

    {
      field: "account.resign_date",
      headerName: "RESIGN DATE",
      sortable: true,
      width: 400,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.resign_date || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1FirstName",
      headerName: "Adult 1 First Name",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 First Name"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1LastName",
      headerName: "Adult 1 Last Name",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Last Name"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2FirstName",
      headerName: "Adult 2 First Name",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 First Name"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2LastName",
      headerName: "Adult 2 Last Name",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Last Name"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1Mobile",
      headerName: "Adult 1 Mobile",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Mobile"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2Mobile",
      headerName: "Adult 2 Mobile",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Mobile"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1Email",
      headerName: "Adult 1 Email",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Email"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2Email",
      headerName: "Adult 2 Email",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Email"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1BirthDate",
      headerName: "Adult 1 Birth date",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Birth date"] ? formatDate({ date: data?.row?.account?.["Adult 1 Birth date"], formatType: "defaultWithUTC" }) : "-"}
        </div>
      ),
    },
    {
      field: "account.adult2BirthDate",
      headerName: "Adult 2 Birth date",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Birth Date"] ? formatDate({ date: data?.row?.account?.["Adult 2 Birth Date"], formatType: "defaultWithUTC" }) : "-"}
        </div>
      ),
    },
    {
      field: "account.adult1Sex",
      headerName: "Adult 1 Sex",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Sex"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2Sex",
      headerName: "Adult 2 Sex",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Sex"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult1Title",
      headerName: "Adult 1 Title",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 1 Title"] || "-"}
        </div>
      ),
    },
    {
      field: "account.adult2Title",
      headerName: "Adult 2 Title",
      sortable: true,
      width: 150,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.["Adult 2 Title"] || "-"}
        </div>
      ),
    },
    {
      field: "member_id",
      headerName: "Member ID",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.member_id ? data?.row?.member_id : "-"}
          </div>
        );
      },
    },
    {
      field: "unsubscribedEmail",
      headerName: "Email Unsubscribe",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.unsubscribedEmail ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "unsubscribedDateEmail",
      headerName: "Email Unsubscribe Date",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.unsubscribedDateEmail ? formatDate({ date: data?.row?.unsubscribedDateEmail, formatType: "defaultWithUTC" }) : "-"}
        </div>
      ),
    },
    {
      field: "unsubscribedText",
      headerName: "Text unsubscribe",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.unsubscribedText ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "unsubscribedDateText",
      headerName: "Text unsubscribe Date",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.unsubscribedDateText ? formatDate({ date: data?.row?.unsubscribedDateText, formatType: "defaultWithUTC" }) : "-"}
        </div>
      ),
    },
    {
      field: "account.hideDirectory",
      headerName: "Hide on member directory",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.hideDirectory ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "account.hideEmail",
      headerName: "Hide email address on member directory",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.hideEmail ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "account.hideMobile",
      headerName: "Hide mobile number on member directory",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.hideMobile ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "account.hideHomeNumber",
      headerName: "Hide home number on member directory",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.hideHomeNumber ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "account.hideAddress",
      headerName: "Hide address on member directory",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.hideAddress ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "last_active",
      headerName: "Last Active",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.last_active
              ? formatDate({ date: data?.row?.last_active, formatType: "defaultWithUTC" })
              : "-"}
          </div>
        );
      },
    },
    {
      field: "mark_as_deceased",
      headerName: "Marked as decease",
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.mark_as_deceased ? "Yes" : "No"}
        </div>
      ),
    },
    {
      field: "account.mailLabelName",
      headerName: "Mail label name",
      sortable: true,
      width: 270,
      renderCell: (data) => (
        <div style={{ color: "grey" }}>
          {data?.row?.account?.mailLabelName || "-"}
        </div>
      ),
    },
    {
      field: "hebrewDateOfBirth.jewishDateStr",
      headerName: "Hebrew Date",
      width: 270,
      renderCell: (data) => {
        return (
          <div style={{ color: "grey" }}>
            {data?.row?.hebrewDateOfBirth?.jewishDateStr ? data?.row?.hebrewDateOfBirth?.jewishDateStr : "-"}
          </div>
        );
      },
    },
    {
      field: "account.wallet.balance",
      headerName: "Credit on Account",
      sortable: true,
      width: 200,
      renderCell: (data) => {
        const balance = data?.row?.account?.wallet?.balance ?? 0;
        return (
          <div style={{ color: balance > 0 ? "#16a34a" : "grey", fontWeight: balance > 0 ? 600 : 400 }}>
            {numberFormat({ number: balance, decimal: 2, style: "currency" })}
          </div>
        );
      },
    },
  ];

  const addFilter = () => {
    let max = 0;
    let resultData = [];
    if (list) {
      list
        ?.map((item) => {
          return Object.keys(item);
        })
        .map((ii, index) => {
          max = ii?.length > max ? ii?.length : max;
          if (max == ii?.length) {
            resultData = ii;
          }
        });
    }

    const filterData = resultData?.map((p) => {
      return p !== "profile_img" && p !== "_id" && p !== "id"
        ? {
          collectionName: "Members",
          fieldName: p,
          displayName: p,
        }
        : "";
    });
    dispatch(filterOrder(filterData));
  };

  const [loading, setLoading] = useState(true);

  React.useEffect(() => {
    if (!state?.length) {
      if (isFetchingRef.current) {
        isFetchingRef.current = false;
        setList([]);
        setLoading(false);
      }
      return;
    }
    isFetchingRef.current = false;
    hasFetchedRef.current = true;
    setLoading(true);
    const data =
      state?.length &&
      state?.map((item) => {
        return {
          ...item,
          ...item?.payment,
          id: item?._id,
          ...(item?.account?.family_name && {
            ["account.family_name"]: item?.account?.family_name,
          }),
          ...(item?.location?.formattedAddress && {
            ["location.formattedAddress"]: item?.location?.formattedAddress,
          }),
          ...(item?.account?.join_date && {
            ["account.join_date"]: item?.account?.join_date,
          }),
          ...(item?.account?.hideDirectory && {
            ["account.hideDirectory"]: item?.account?.hideDirectory,
          }),
          ...(item?.account?.hideEmail && {
            ["account.hideEmail"]: item?.account?.hideEmail,
          }),
          ...(item?.account?.hideMobile && {
            ["account.hideMobile"]: item?.account?.hideMobile,
          }),
          ...(item?.account?.hideHomeNumber && {
            ["account.hideHomeNumber"]: item?.account?.hideHomeNumber,
          }),
          ...(item?.account?.hideAddress && {
            ["account.hideAddress"]: item?.account?.hideAddress,
          }),
          ...(item?.account?.numberOfFamilyMembers && {
            ["account.numberOfFamilyMembers"]:
              item?.account?.numberOfFamilyMembers,
          }),
          ...(item?.account?.admin_name && {
            ["account.admin_name"]: item?.account?.admin_name,
          }),
          ...(item?.account?.admin_contact && {
            ["account.admin_contact"]: item?.account?.admin_contact,
          }),
          ...(item?.account?.country && {
            ["account.addresses.country"]: item.account?.addresses?.map(
              (item) => {
                return item?.country;
              }
            )[0],
          }),
          ...(item?.account?.tags && {
            ["account.tags"]: item?.account?.tags?.map((item) => {
              return item;
            }),
          }),
          ...(item?.tags && {
            ["tags"]: item?.tags?.map((item) => {
              return item;
            }),
          }),
          ...(item?.account?.payment?.account_type && {
            ["account.payment.account_type"]:
              item?.account?.payment?.account_type,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.zip_code && {
            ["account.addresses.billing_zip_code"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.zip_code,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.zip_code && {
            ["account.addresses.active_zip_code"]:
              item?.account?.addresses?.find((item) => {
                if (item?.active == true) {
                  return item;
                }
              })?.zip_code,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.city && {
            ["account.addresses.billing_city"]: item?.account?.addresses?.find(
              (o, i) => {
                if (o.billing === true) {
                  return o;
                }
              }
            )?.city,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.city && {
            ["account.addresses.active_city"]: item?.account?.addresses?.find(
              (item) => {
                if (item?.active == true) {
                  return item?.city;
                }
              }
            )?.city,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.addressLine2 && {
            ["account.addresses.active_addressLine2"]:
              item?.account?.addresses?.find((item) => {
                if (item?.active == true) {
                  return item?.addressLine2;
                }
              })?.addressLine2,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.addressLine2 && {
            ["account.addresses.billing_addressLine2"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.addressLine2,
          }),
          ...(item?.account?.addresses?.find((item) => {
            if (item?.active == true) {
              return item;
            }
          })?.state && {
            ["account.addresses.active_state"]: item?.account?.addresses?.find(
              (item) => {
                if (item?.active == true) {
                  return item;
                }
              }
            )?.state,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.state && {
            ["account.addresses.billing_state"]: item?.account?.addresses?.find(
              (o, i) => {
                if (o.billing === true) {
                  return o;
                }
              }
            )?.state,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.country && {
            ["account.addresses.billing_country"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.country,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.active === true) {
              return o;
            }
          })?.country && {
            ["account.addresses.active_country"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })?.country,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.active === true) {
              return o;
            }
          })?.neighborhood && {
            ["account.addresses.active_neighborhood"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })?.neighborhood,
          }),
          ...(item?.account?.addresses?.find((o, i) => {
            if (o.billing === true) {
              return o;
            }
          })?.neighborhood && {
            ["account.addresses.billing_neighborhood"]:
              item?.account?.addresses?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })?.neighborhood,
          }),
          ...(item?.account?.addresses
            ?.find((o, i) => {
              if (o.active === true) {
                return o;
              }
            })
            ?.location?.formattedAddress?.split(",")[0] && {
            ["account.addresses.active_address"]: item?.account?.addresses
              ?.find((o, i) => {
                if (o.active === true) {
                  return o;
                }
              })
              ?.location?.formattedAddress?.split(",")[0],
          }),
          ...(item?.account?.addresses
            ?.find((o, i) => {
              if (o.billing === true) {
                return o;
              }
            })
            ?.location?.formattedAddress?.split(",")[0] && {
            ["account.addresses.billing_address"]: item?.account?.addresses
              ?.find((o, i) => {
                if (o.billing === true) {
                  return o;
                }
              })
              ?.location?.formattedAddress?.split(",")[0],
          }),
          ...(item?.account?.addresses?.map((item) => {
            if (item?.active == true) {
              return item?.neighborhood;
            }
          })[0] && {
            ["account.addresses.active_neighborhood"]:
              item?.account?.addresses?.map((item) => {
                if (item?.active == true) {
                  return item?.neighborhood;
                }
              })[0],
          }),
          ...(item?.account?.addresses?.map((item) => {
            if (item?.billing == true) {
              return item?.neighborhood;
            }
          })[0] && {
            ["account.addresses.billing_neighborhood"]:
              item?.account?.addresses?.map((item) => {
                if (item?.billing == true) {
                  return item?.neighborhood;
                }
              })[0],
          }),
          // ...(item?.account?.addresses?.map((item) => {
          //   if (item?.billing == true) {
          //     return item?.location?.formattedAddress;
          //   }
          // })[0] && {
          //   ["account.addresses.active_address"]: item?.addresses
          //     ?.map((item) => {
          //       if (item?.active == true) {
          //         return item?.location?.formattedAddress?.replace(/,/g, "");
          //       }
          //     })[0]
          //     ?.replace(/,/g, ""),
          // }),
          // ...(item?.account?.addresses?.map((item) => {
          //   if (item?.billing == true) {
          //     return item?.location?.formattedAddress;
          //   }
          // })[0] && {
          //   ["account.addresses.billing_address"]: item?.addresses
          //     ?.map((item) => {
          //       if (item?.billing == true) {
          //         return item?.location?.formattedAddress?.replace(/,/g, "");
          //       }
          //     })[0]
          //     ?.replace(/,/g, ""),
          // }),
          ...(item?.account?.old_account_id && {
            ["account.old_account_id"]: item?.account?.old_account_id,
          }),
          ...(item?.account?.account_id && {
            ["account.account_id"]: item?.account?.account_id,
          }),
          ...(item?.account?.payment?.account_sub_type?.title && {
            ["account.payment.account_sub_type.title"]:
              item?.account?.payment?.account_sub_type?.title,
          }),
          ...(item?.account?.payment?.billing_type?.title && {
            ["account.payment.billing_type.title"]:
              item?.account?.payment?.billing_type?.title,
          }),
          ...(item?.account?.join_date && {
            ["account.join_date"]: item?.account?.join_date,
          }),
          ...(item?.account?.numberOfFamilyMembers && {
            ["account.numberOfFamilyMembers"]:
              item?.account?.numberOfFamilyMembers,
          }),
          ...(item?.account?.resign_date && {
            ["account.resign_date"]: formatDate({ date: item?.account?.resign_date, formatType: "defaultWithUTC" }),
          }),
          ...(item?.account?.["Adult 1 First Name"] && {
            ["account.adult1FirstName"]:
              item?.account?.["Adult 1 First Name"],
          }),
          ...(item?.account?.["Adult 1 Last Name"] && {
            ["account.adult1LastName"]:
              item?.account?.["Adult 1 Last Name"],
          }),
          ...(item?.account?.["Adult 2 First Name"] && {
            ["account.adult2FirstName"]:
              item?.account?.["Adult 2 First Name"],
          }),
          ...(item?.account?.["Adult 2 Last Name"] && {
            ["account.adult2LastName"]:
              item?.account?.["Adult 2 Last Name"],
          }),
          ...(item?.account?.["Adult 1 Title"] && {
            ["account.adult1Title"]:
              item?.account?.["Adult 1 Title"],
          }),
          ...(item?.account?.["Adult 2 Title"] && {
            ["account.adult2Title"]:
              item?.account?.["Adult 2 Title"],
          }),
          ...(item?.account?.["Adult 1 Mobile"] && {
            ["account.adult1Mobile"]: item?.account?.["Adult 1 Mobile"],
          }),
          ...(item?.account?.["Adult 2 Mobile"] && {
            ["account.adult2Mobile"]: item?.account?.["Adult 2 Mobile"],
          }),
          ...(item?.account?.["Adult 1 Email"] && {
            ["account.adult1Email"]: item?.account?.["Adult 1 Email"],
          }),
          ...(item?.account?.["Adult 2 Email"] && {
            ["account.adult2Email"]: item?.account?.["Adult 2 Email"],
          }),
          ...(item?.account?.["Adult 1 Birth date"] && {
            ["account.adult1BirthDate"]:
              formatDate({ date: item?.account?.["Adult 1 Birth date"], formatType: "defaultWithUTC" }),
          }),
          ...(item?.account?.["Adult 2 Birth date"] && {
            ["account.adult2BirthDate"]:
              formatDate({ date: item?.account?.["Adult 2 Birth date"], formatType: "defaultWithUTC" }),
          }),
          ...(item?.account?.["Adult 1 Sex"] && {
            ["account.adult1Sex"]: item?.account?.["Adult 1 Sex"],
          }),
          ...(item?.account?.["Adult 2 Sex"] && {
            ["account.adult2Sex"]: item?.account?.["Adult 2 Sex"],
          }),
          
          ...(item?.account?.["Hide on member directory"] && {
            ["account.hideDirectory"]: item?.account?.hideDirectory,
          }),
          ...(item?.account?.["Hide email address on member directory"] && {
            ["account.hideEmail"]: item?.account?.hideEmail,
          }),
          ...(item?.account?.["Hide mobile number on member directory"] && {
            ["account.hideMobile"]: item?.account?.hideMobile,
          }),
          ...(item?.account?.["Hide home number on member directory"] && {
            ["account.hideHomeNumber"]: item?.account?.hideHomeNumber,
          }),
          ...(item?.account?.["Hide address on member directory"] && {
            ["account.hideAddress"]: item?.account?.hideAddress,
          }),
          ...(item?.account?.mailLabelName && {
            ["account.mailLabelName"]: item?.account?.mailLabelName,
          }),
          ...(item?.hebrewDateOfBirth?.jewishDateStr && {
            ["hebrewDateOfBirth.jewishDateStr"]: item?.hebrewDateOfBirth?.jewishDateStr,
          }),
        };
      });
    setTimeout(() => {
      setLoading(false);
    }, 2100);

    setTimeout(() => {
      setList(data || []);
    }, 2000);
    if (data?.length) {
      const runReportFieldNames = list
        ?.map((item) => {
          return Object.keys(item);
        })[0]
        ?.map((p) => {
          return {
            collectionName: "Members",
            fieldName: p,
            displayName: "Phone",
          };
        });
      const getNestedValue = (obj, path) =>
        path?.split(".").reduce((acc, key) => acc?.[key], obj);
      const ColumnsDownlod = columns?.map((columnData) => {
        const dataForColumn = data?.map((rowData, index) => {
          if (columnData?.field === "account.wallet.balance") {
            return rowData?.account?.wallet?.balance ?? 0;
          }
          const val = rowData[columnData?.field] ?? getNestedValue(rowData, columnData?.field);
          return val;
        });
        const foundFromParams = _.find(
          newFieldsOrder,
          (item) => item?.fieldName === columnData?.field
        );
        if (foundFromParams) {
          return {
            id: columnData?.field,
            displayName: columnData?.headerName,
            dataForColumn,
          };
        }
      });
      let newArray = [];
      const ColumnsDownlodFilter = _.filter(ColumnsDownlod, (item) => item);
      const RowDownlod = ColumnsDownlodFilter?.map((download, index) => {
        const updatedData = download?.dataForColumn?.map((dataForColumn) => {
          const foundFromParams = _.find(
            newFieldsOrder,
            (item) => item?.fieldName === download.id
          );
          if (foundFromParams) {
            let updatedDataForColumn = dataForColumn;
            if (
              (download.id === "home_phone" ||
                download.id === "mobile_number") &&
              dataForColumn
            ) {
              updatedDataForColumn = formatPhoneNumber(dataForColumn);
            }
            if (download.id === "date_of_birth" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "next_birthday" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "next_anniversary" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "anniversary_date" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "metva_date" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "account.join_date" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "account.resign_date" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "location.formattedAddress" && dataForColumn) {
              updatedDataForColumn = dataForColumn;
            }
            if (download.id === "unsubscribedEmail") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "unsubscribedDateEmail" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "unsubscribedText") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "unsubscribedDateText" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }
            if (download.id === "mark_as_deceased") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.hideDirectory") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.hideEmail") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.hideMobile") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.hideHomeNumber") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.hideAddress") {
              updatedDataForColumn = dataForColumn ? "Yes" : "No";
            }
            if (download.id === "account.wallet.balance") {
              updatedDataForColumn = numberFormat({ number: dataForColumn ?? 0, decimal: 2, style: "currency" });
            }
            if (download.id === "last_active" && dataForColumn) {
              updatedDataForColumn = formatDate({ date: dataForColumn, formatType: "defaultWithUTC" });
            }

            return {
              [download.id]: updatedDataForColumn,
            };
          }
        });
        if (newArray?.length) {
          newArray = newArray.map((array, index2) => {
            return {
              ...array,
              ...updatedData[index2],
            };
          });
        } else {
          newArray = updatedData;
        }
        setDatasDownload(newArray);
      });
      setColumnsDownload(ColumnsDownlodFilter);
    }
  }, [state, id]);

  const getColumnData = (columnData) => {
    // const runReportFieldNames = list
    //   ?.map((item) => {
    //     return Object.keys(item);
    //   })[0]
    //   ?.map((p) => {
    //     return {
    //       collectionName: "Members",
    //       fieldName: p,
    //       displayName: p,
    //     };
    //   });
    const updatedData = columnData?.filter((selectedColumn) => {
      if (fieldsOrder?.length !== 0) {
        const foundcolumn = _.find(
          newFieldsOrder,
          (fileds) => selectedColumn?.field === fileds?.fieldName
        );
        return foundcolumn?.fieldName;
      } else {
        const foundcolumn = _.find(
          newFieldsOrder,
          (fileds) => selectedColumn?.field === fileds?.fieldName
        );
        return foundcolumn?.fieldName;
      }
    });
    const sortData = _.sortBy(updatedData, (x) =>
      _.findIndex(newFieldsOrder, (y) => x.field === y?.fieldName)
    );
    return sortData;
  };

  React.useEffect(() => {
    async function fetchMyAPI() {
      const token = await getAccessTokenSilently();
      if (id) setGetDataByIdLoading(true)
      {
        id
          ? AuthService.getFilterById(id, token)
            .then((res) => {
              setFilterDisplay(res?.selectedFieldsOrder);
              setFilters(res?.selectedFields)
              if (whichPage == "results") {
                dispatch(filterOrderFieldType(res?.isLabeled ? "labels-output" : "order-fields"));
              }
            })
            .catch((err) => toastr.error("Error", err?.data?.message))
            .finally(() => {
              setGetDataByIdLoading(false)
            })
          : {};
      }
    }
    fetchMyAPI();
  }, [id, getAccessTokenSilently]);

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  //for print
  const componentRef = useRef();
  const tableDownlaodRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => setPrintList(null),
  });

  const fetchAllForAction = async () => {
    const token = await getAccessTokenSilently();
    let payload;
    if (whichPage == "results" && id) {
      const filterDef = await AuthService.getFilterById(id, token);
      payload = {
        selectedFields: filterDef?.selectedFields || [],
        selectedFieldsOrder: filterDef?.selectedFieldsOrder || [],
      };
    } else {
      const parameterValues = fieldsGroup || {};
      const orderValues = fieldsOrder || [];
      payload = {
        filterName: "",
        selectedFields: Object.keys(parameterValues).map((key) => {
          const mainArray = parameterValues[key].values;
          const lineContainsArray = (mainArray === null || mainArray === undefined) ? true : Array.isArray(mainArray[0]);
          const hasComma = parameterValues[key].values?.includes?.(',');
          const fieldValue = lineContainsArray
            ? parameterValues[key].values?.[0] === null ? "" : parameterValues[key].values?.[0]
            : parameterValues[key].values === null ? ""
            : parameterValues[key].operator === 10 && typeof parameterValues[key]?.values === "string" ? parameterValues[key]?.values?.split(",")
            : parameterValues[key].operator === 7 || parameterValues[key].operator === 8
              ? hasComma ? parameterValues[key]?.values?.split(' , ') : [parameterValues[key].values]
              : parameterValues[key].values || [];
          return {
            fieldName: key,
            operator: parameterValues[key].operator,
            type: parameterValues[key].oprInputType,
            displayName: parameterValues[key].displayName,
            fieldValue,
            collectionName: parameterValues[key]?.collectionName || "",
          };
        }),
        selectedFieldsOrder: orderValues.map(({ collectionName, fieldName }, index) => ({ collectionName, fieldName, order: index + 1 })),
      };
    }
    const res = await AuthService.sendFilterParams(payload, token);
    return res?.payload?.data ?? res?.data ?? (Array.isArray(res) ? res : []);
  };

  const handlePrintClick = async () => {
    try {
      setPrintLoading(true);
      const allItems = await fetchAllForAction();
      setPrintList(allItems);
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Print failed");
    } finally {
      setPrintLoading(false);
    }
  };

  React.useEffect(() => {
    if (printList !== null) {
      handlePrint();
    }
  }, [printList]);

  React.useEffect(() => {
    if (exportDatas !== null && exportCsvRef.current) {
      exportCsvRef.current.handleClick();
      setExportDatas(null);
    }
  }, [exportDatas]);

  const handleExportClick = async () => {
    try {
      setExportLoading(true);
      const allItems = await fetchAllForAction();
      console.log("[Export] selectedFieldorders:", JSON.stringify(selectedFieldorders));
      console.log("[Export] first item account keys:", Object.keys(allItems?.[0]?.account || {}));
      console.log("[Export] first item account.category:", allItems?.[0]?.account?.category);
      const getNestedVal = (obj, path) => path?.split(".").reduce((acc, key) => acc?.[key], obj);

      const rows = allItems.map((item) => {
        const obj = {};
        selectedFieldorders?.forEach((order) => {
          const colId = displayNameToExportId[order?.displayName] || order?.fieldName;
          if (!colId) return;
          let value;
          const dn = order?.displayName;
          const fn = order?.fieldName;

          // Address fields — same logic as print table
          if (dn === "Active City") value = item?.account?.addresses?.find(a => a.active)?.city;
          else if (dn === "Active State") value = item?.account?.addresses?.find(a => a.active)?.state;
          else if (dn === "Active Country") value = item?.account?.addresses?.find(a => a.active)?.country;
          else if (dn === "Active Zip code") value = item?.account?.addresses?.find(a => a.active)?.zip_code;
          else if (dn === "Active Neighborhood") value = item?.account?.addresses?.find(a => a.active)?.neighborhood;
          else if (dn === "Active Address Line 2") value = item?.account?.addresses?.find(a => a.active)?.addressLine2;
          else if (dn === "Active Address") value = item?.account?.addresses?.find(a => a.active)?.location?.formattedAddress?.split(",")[0];
          else if (dn === "Billing City") value = item?.account?.addresses?.find(a => a.billing)?.city;
          else if (dn === "Billing State") value = item?.account?.addresses?.find(a => a.billing)?.state;
          else if (dn === "Billing Country") value = item?.account?.addresses?.find(a => a.billing)?.country;
          else if (dn === "Billing Zip code") value = item?.account?.addresses?.find(a => a.billing)?.zip_code;
          else if (dn === "Billing Neighborhood") value = item?.account?.addresses?.find(a => a.billing)?.neighborhood;
          else if (dn === "Billing Address Line 2") value = item?.account?.addresses?.find(a => a.billing)?.addressLine2;
          else if (dn === "Billing Address") value = item?.account?.addresses?.find(a => a.billing)?.location?.formattedAddress?.split(",")[0];

          // Adult fields — stored as account["Adult 1 First Name"] etc.
          else if (dn?.includes("Adult")) {
            const raw = item?.account?.[fn];
            if (raw && (dn?.includes("Birth date") || dn?.includes("birth date"))) {
              value = formatDate({ date: raw, formatType: "defaultWithUTC" });
            } else if (raw && (dn?.includes("Mobile") || dn?.includes("mobile"))) {
              value = formatPhoneNumber(raw);
            } else {
              value = raw;
            }
          }

          // Home phones
          else if (dn === "Home 1") value = item?.account?.["Home 1"] ? formatPhoneNumber(item.account["Home 1"]) : undefined;
          else if (dn === "Home 2") value = item?.account?.["Home 2"] ? formatPhoneNumber(item.account["Home 2"]) : undefined;

          // Category — array of strings or objects, matched by displayName or fieldName
          else if (dn?.toLowerCase()?.includes("category") || fn?.toLowerCase()?.includes("category")) {
            const cat = item?.account?.category ?? item?.category ?? getNestedVal(item, fn);
            if (Array.isArray(cat)) value = cat.map(c => c?.title || c).join(", ");
            else value = cat;
          }

          // Admin fields
          else if (dn === "Admin Name" || dn === "Family Admin Name" || fn === "account.admin_name") value = item?.account?.admin_name;
          else if (dn === "Admin Contact" || dn === "Family Admin Contact" || fn === "account.admin_contact") value = item?.account?.admin_contact ? formatPhoneNumber(item?.account?.admin_contact) : undefined;

          // Emergency contact — phone number
          else if (fn === "emergency_contact_number") value = item?.emergency_contact_number ? formatPhoneNumber(item?.emergency_contact_number) : undefined;

          // Archived account
          else if (dn === "Archived account" || fn === "account.archived") value = item?.account?.archived ? "Yes" : "No";
          else if (dn === "Archived contact" || fn === "archived") value = item?.archived ? "Yes" : "No";
          else if (dn === "Contact id" || fn === "_id") value = item?._id;

          // Wallet balance
          else if (fn === "account.wallet.balance") value = item?.account?.wallet?.balance ?? 0;

          // Boolean display fields
          else if (fn === "unsubscribedEmail" || fn === "unsubscribedText" || fn === "mark_as_deceased") {
            value = item?.[fn] ? "Yes" : "No";
          }
          else if (fn === "account.hideDirectory") value = item?.account?.hideDirectory ? "Yes" : "No";
          else if (fn === "account.hideEmail") value = item?.account?.hideEmail ? "Yes" : "No";
          else if (fn === "account.hideMobile") value = item?.account?.hideMobile ? "Yes" : "No";
          else if (fn === "account.hideHomeNumber") value = item?.account?.hideHomeNumber ? "Yes" : "No";
          else if (fn === "account.hideAddress") value = item?.account?.hideAddress ? "Yes" : "No";

          // Date fields
          else if (fn === "date_of_birth" || fn === "next_birthday" || fn === "next_anniversary" || fn === "anniversary_date" || fn === "metva_date" || fn === "last_active" || fn === "account.join_date" || fn === "account.resign_date" || fn === "unsubscribedDateEmail" || fn === "unsubscribedDateText" || dn === "Anniversary" || dn === "Bar/Bat Mitzvah") {
            const raw = item?.[fn] ?? getNestedVal(item, fn);
            value = raw ? formatDate({ date: raw, formatType: "defaultWithUTC" }) : undefined;
          }

          // Phone fields
          else if (fn === "home_phone" || fn === "mobile_number") {
            const raw = item?.[fn];
            value = raw ? formatPhoneNumber(raw) : undefined;
          }

          // Tags
          else if (fn === "account.tags" || fn === "tags") {
            const t = fn === "tags" ? item?.tags : item?.account?.tags;
            value = Array.isArray(t) ? t.sort((a, b) => a?.toLowerCase?.().localeCompare(b?.toLowerCase?.())).join(" , ") : t;
          }

          // Generic: try direct key, then nested path, then account[fieldName]
          else {
            const raw = item?.[fn] ?? getNestedVal(item, fn) ?? item?.account?.[fn];
            value = Array.isArray(raw) ? raw.map(c => c?.title || c).join(", ") : raw;
          }

          if (value !== undefined && value !== null && value !== "") obj[colId] = value;
        });
        return obj;
      });
      setExportDatas(rows);
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Export failed");
    } finally {
      setExportLoading(false);
    }
  };

  const handleDownload = async () => {
    html2canvas(tableDownlaodRef?.current)
      .then((canvas) => {
        const pdf = new jsPDF();
        let width = 200;
        let height = 0;
        const imgData = canvas.toDataURL("image/png");
        pdf.addImage(imgData, "PNG", 5, 5, width, height);
        pdf.save("Statement.pdf");
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
  };

  const ComponentToPrint = () => {
    const printData = printList || list;
    return (
      <div ref={componentRef}>
        {fieldsOrder && printData && (
          <table>
            <thead>
              {fieldsOrder?.map((column, index) => (
                <th style={{ border: "1px solid" }} key={index}>
                  {column?.displayName}
                </th>
              ))}
            </thead>
            <tbody>
              {printData?.map((row, _index) => (
                <tr key={_index}>
                  {fieldsOrder?.map((column, index) => (
                    <td style={{ border: "1px solid" }} key={index}>
                      {resolveFieldValue(row, column)}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    );
  };

  let whichPage = localStorage.getItem("goto");
  React.useEffect(() => {
    const getById = async () => {
      const token = await getAccessTokenSilently();
      setLoading(true);
      dispatch(getFilterData({ id, token, pagination: { items_per_page: ITEMS_PER_PAGE, current_page: currentPage }, sort: sortField ? { [sortField]: sortDir } : {} }));
    };
    if (whichPage == "results") {
      isFetchingRef.current = true;
      hasFetchedRef.current = true;
      getById().finally(() => {
        isFetchingRef.current = false;
      });
    }
  }, [id, currentPage, sortField, sortDir]);

  const prevStateRef = React.useRef(state);
  React.useEffect(() => {
    if (prevStateRef.current?.length > 0 && state?.length === 0) {
      setCurrentPage(1);
      setSortField(null);
      setSortDir(1);
    }
    prevStateRef.current = state;
  }, [state]);

  const paginationMountedRef = React.useRef(false);
  React.useEffect(() => {
    if (whichPage == "results") return;
    if (!paginationMountedRef.current) {
      paginationMountedRef.current = true;
      return;
    }
    const refetch = async () => {
      const token = await getAccessTokenSilently();
      isFetchingRef.current = true;
      hasFetchedRef.current = true;
      setLoading(true);
      await dispatch(fetchProducts({ token, pagination: { items_per_page: ITEMS_PER_PAGE, current_page: currentPage }, sort: sortField ? { [sortField]: sortDir } : {} }));
      isFetchingRef.current = false;
    };
    refetch();
  }, [currentPage, sortField, sortDir]);

  React.useEffect(() => {
    if (filterLoading) {
      isFetchingRef.current = true;
      hasFetchedRef.current = true;
    }
  }, [filterLoading]);

  React.useEffect(() => {
    if (!filterLoading && hasFetchedRef.current && !state?.length) {
      isFetchingRef.current = false;
      setList([]);
      setLoading(false);
    }
  }, [filterLoading, state]);

  const [downloadLabelLoading, setDownloadLabelLoading] = React.useState(false);

  const downloadMailingLabelHandler = async () => {
    const countryCode = orgData?.country?.code ? orgData?.country?.code?.toLowerCase() : "us";
    let allItems;
    try {
      setDownloadLabelLoading(true);
      allItems = await fetchAllForAction();
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Download failed");
      setDownloadLabelLoading(false);
      return;
    }
    const fieldsData = allItems?.map((item) => {
      const activeAddress1 = item?.account?.addresses?.find((item) => item?.active == true)?.location?.formattedAddress?.split(",")[0] ?? ""
      const billingAddress1 = item?.account?.addresses?.find((item) => item?.billing == true)?.location?.formattedAddress?.split(",")[0] ?? "";
      const activeAddress2 = item?.account?.addresses?.find((item) => item?.active == true)?.addressLine2 || "";
      const billingAddress2 = item?.account?.addresses?.find((item) => item?.billing == true)?.addressLine2 || "";
      const activeCity = item?.account?.addresses?.find((item) => item?.active == true)?.city || "";
      const billingCity = item?.account?.addresses?.find((item) => item?.billing == true)?.city || "";
      const activeZipCode = item?.account?.addresses?.find((item) => item?.active == true)?.zip_code || "";
      const billingZipCode = item?.account?.addresses?.find((item) => item?.billing == true)?.zip_code || "";
      const activeState = item?.account?.addresses?.find((item) => item?.active == true)?.state || "";
      const billingState = item?.account?.addresses?.find((item) => item?.billing == true)?.state || "";
      const activeCountry = item?.account?.addresses?.find((item) => item?.active == true)?.country || "";
      const billingCountry = item?.account?.addresses?.find((item) => item?.billing == true)?.country || "";

      return {
        mailingLabelName: item?.account?.mailLabelName,
        address1: selectedAddress === "active-address" ? activeAddress1 !== "undefined" ? activeAddress1 : "" : billingAddress1 !== "undefined" ? billingAddress1 : "",
        address2: selectedAddress === "active-address" ? activeAddress2 !== "undefined" ? activeAddress2 : "" : billingAddress2 !== "undefined" ? billingAddress2 : "",
        city: selectedAddress === "active-address" ? activeCity !== "undefined" ? activeCity : "" : billingCity !== "undefined" ? activeCity : "",
        zipCode: selectedAddress === "active-address" ? activeZipCode !== "undefined" ? activeZipCode : "" : billingZipCode !== "undefined" ? billingZipCode : "",
        state: selectedAddress === "active-address" ? activeState !== "undefined" ? activeState : "" : billingState !== "undefined" ? billingState : "",
        country: selectedAddress === "active-address" ? activeCountry !== "undefined" ? activeCountry : "" : billingCountry !== "undefined" ? billingCountry : "",
      }
    }).filter((item) => (countryCode === "us" && item?.address1 && item?.city && item?.state) || (countryCode !== "us" && item?.address1 && item?.city));

    try {
      const blob = await pdf(<MailingLabelsDocument data={fieldsData} />).toBlob();
      saveAs(blob, "mailing");
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Download failed");
    } finally {
      setDownloadLabelLoading(false);
    }
  }
  return (
    <>
      <div className="results ">
        <div className="heading d-flex align-items-center">
          {filterId
            ? filterDisplay?.filterName
            : location?.state?.value
              ? location?.state?.value
              : "See the Results"}
          <InfoTooltip text="These are the members that currently match your filter. Save the segment to reuse it later, or export/print this list now." placement="bottom" useFixed style={{ marginLeft: '6px' }} />
        </div>
        <div className="options">

          {(orderFieldType === "labels-output" && !loading && !getDataByIdLoading && !!state?.length) && (
            <div className="svg-filters" onClick={downloadLabelLoading ? undefined : downloadMailingLabelHandler} style={{ opacity: downloadLabelLoading ? 0.6 : 1, pointerEvents: downloadLabelLoading ? "none" : "auto" }}>
              <ExportSvgComponent /> {downloadLabelLoading ? "Downloading..." : "Download"}
            </div>
          )}
          {(orderFieldType === "order-fields" && !loading && !getDataByIdLoading && !!state?.length) && (
            <>
              <div className="svg-filters" onClick={handleExportClick} style={{ opacity: exportLoading ? 0.6 : 1, pointerEvents: exportLoading ? "none" : "auto" }}>
                <ExportSvgComponent /> {exportLoading ? "Exporting..." : "Export"}
              </div>
              <div style={{ display: "none" }}>
                <CsvDownloader
                  ref={exportCsvRef}
                  filename={
                    localStorage.getItem("organization")
                      ? JSON.parse(localStorage.getItem("organization"))?.orgName
                      : "EazyTemple"
                  }
                  extension=".csv"
                  columns={orderColumnsDownload}
                  wrapColumnChar='"'
                  datas={sanitizeRows(exportDatas || [])}
                />
              </div>
              <div className="svg-filters" onClick={handlePrintClick} style={{ opacity: printLoading ? 0.6 : 1, pointerEvents: printLoading ? "none" : "auto" }}>
                <PrintSvgComponent /> {printLoading ? "Loading..." : "Print"}
              </div>
            </>
          )}

          <div className="save-filter-button">
            <Button
              variant="primary"
              size="md"
              style={{
                border: "none",
                minWidth: "120px",
              }}
              onClick={() => setOpen(true)}
            >
              {location?.state?.isRunSegment ? "Rename Segment" : id ? "Edit Segment" : "Save Segment"}
            </Button>
          </div>
        </div>
      </div>
      <MyModal
        open={openFilter}
        onClose={handleCloseFilter}
        className="filter-card"
      >
        <Filter from="resultFilter" />
      </MyModal>
      <div className="search-table-container reports-results-table">
        {(loading || filterLoading) ? (
          <div className="w-100 h-100 d-flex justify-content-center align-items-center">
            <Loader />
          </div>
        ) : list?.length >= 0 ? (
          <div useRef={tableDownlaodRef}>
            <TableContainer component={Paper} className="member-table">
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow
                    style={{
                      backgroundColor: "#f3f6f9",
                    }}
                  >
                    {fieldsOrder?.map((column, index) => (
                      <TableCell
                        key={index}
                        style={{ width: "220", cursor: sortableLookup[column?.fieldName] ? "pointer" : "default", userSelect: "none" }}
                        className="billing-name"
                        align="left"
                        onClick={() => {
                          if (!sortableLookup[column?.fieldName]) return;
                          if (sortField === column?.fieldName) {
                            setSortDir(prev => prev === 1 ? -1 : 1);
                          } else {
                            setSortField(column?.fieldName);
                            setSortDir(1);
                          }
                          setCurrentPage(1);
                        }}
                      >
                        {column?.displayName}
                        {sortableLookup[column?.fieldName] && (
                          <IconButton size="small" style={{ marginLeft: "6px" }}>
                            <SortIcon style={{ opacity: sortField === column?.fieldName ? 1 : 0.35, width: "12px", height: "12px" }} />
                          </IconButton>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {!loading && !filterLoading && hasFetchedRef.current && !list?.length && (
                    <TableRow>
                      <TableCell colSpan={fieldsOrder?.length || 1} style={{ color: "#a0a0b0", padding: "60px 32px", fontSize: "15px", fontWeight: 400 }}>
                        <div style={{ textAlign: "center", width: "100%" }}>No data found</div>
                      </TableCell>
                    </TableRow>
                  )}
                  {list?.map((row, _index) => (
                    <TableRow key={_index}>
                      {fieldsOrder?.map((column, index) => (
                        <TableCell
                          style={{
                            width: "220",
                          }}
                          className={index}
                          key={index}
                          align="left"
                        >
                          {resolveFieldValue(row, column)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        ) : (
          list?.length === 0 &&
          loading === false && (
            <div className="w-100 h-100 d-flex justify-content-center align-items-center">
              {"No Record"}
            </div>
          )
        )}
        <div style={{ display: "none" }}>{ComponentToPrint()}</div>
        {totalCount > ITEMS_PER_PAGE && (
          <div style={{ display: "flex", justifyContent: "center", padding: "16px 30px" }}>
            <Pagination
              count={Math.ceil(totalCount / ITEMS_PER_PAGE)}
              page={currentPage}
              color="primary"
              variant="outlined"
              onChange={(_, p) => {
                setCurrentPage(p);
              }}
            />
          </div>
        )}
      </div>
      <hr />
      <div style={{ padding: "30px", display: "flex", gap: "12px" }}>
        <MyButton
          content="Cancel"
          style={{ width: "100px", marginBottom: "25px", background: "#fff", border: "1px solid #2555ef", color: "#2555ef" }}
          onClick={() => push("/report")}
        />
        <MyButton
          content="Previous"
          style={{
            width: "100px",
            marginBottom: "25px",
            display: location?.state?.value || whichPage == "results" ? "none" : "",
          }}
          onClick={goToOrder}
          disabled={whichPage == "results" ? true : false}
        />
      </div>
      <div>
        <SaveFilter
          openModal={open}
          closeModal={() => setOpen(false)}
          id={id}
          filters={filters}
          isRunSegment={!!location?.state?.isRunSegment}
        />
      </div>
    </>
  );
};

export default SearchResult;
